import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ImHome2, ImInfo } from "react-icons/im"
import { MdOutlineApartment, MdOutlineDashboardCustomize } from "react-icons/md"
import { GrServices } from "react-icons/gr"
import { IoMailOutline } from "react-icons/io5"
import utils from '../../utils'
import { useApp } from '../../context/AppContext'

function Drawer() {
    const { isAuth } = useApp()
    const location = useLocation()

    const baseNavItems = [
    { to: '/', label: 'Home', icon: <ImHome2 /> },
    { to: '/houses', label: 'Houses', icon: <MdOutlineApartment /> },
    { to: '/services', label: 'Services', icon: <GrServices /> },
    { to: '/about', label: 'About', icon: <ImInfo /> },
    { to: '/contact', label: 'Contact', icon: <IoMailOutline /> },
];

    const navItems = isAuth
        ? [...baseNavItems, { to: '/auth/dashboard', label: 'Dashboard', icon: <MdOutlineDashboardCustomize /> }]
        : baseNavItems

    const handleNavClick = (e) => {
        if (e.target.closest('a')) {
            document.getElementById("nav-drawer")?.click()
        }
    }

    return (
        <div className="drawer-side z-30">
            <label htmlFor="nav-drawer" className="drawer-overlay"></label>

            <div className="p-6 w-72 bg-base-100 h-full flex flex-col shadow-xl">
                <div className="py-10 flex justify-center">
                    <Link
                        to="/"
                        className="text-2xl font-serif font-bold text-[#0F1715] tracking-tight uppercase"
                    >
                        {utils.siteName}
                    </Link>
                </div>
                <ul onClick={handleNavClick} className="menu flex-1 gap-2 p-0">
                    {navItems.map((item) => {
                        const isActive = location.pathname === item.to
                        return (
                            <li key={item.to} className="p-0">
                                <Link
                                    to={item.to}
                                    className={`
                                        flex items-center gap-3 px-4 py-3 rounded-r-xl text-sm uppercase tracking-widest font-medium transition-all duration-200 border-l-4
                                        ${isActive
                                            ? 'text-orange-500 font-bold border-orange-500 bg-orange-50'
                                            : 'text-[#0F1715]/60 hover:text-[#0F1715] hover:bg-base-200 border-transparent'
                                        }
                                    `}
                                >
                                    <span className={`text-lg transition-colors ${isActive ? 'text-orange-500' : 'text-[#0F1715]/40'}`}>
                                        {item.icon}
                                    </span>
                                    {item.label}
                                </Link>
                            </li>
                        )
                    })}
                </ul>
                <div className="pt-8 pb-4 space-y-3">
                    <Link
                        to="/contact"
                        className="block text-center bg-[#1B4D3E] text-white px-6 py-3.5 w-full rounded-xl text-xs uppercase tracking-widest font-bold hover:bg-[#143a2f] active:scale-[0.98] transition-all shadow-md shadow-primary/20"
                    >
                        Book / Inquire
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default Drawer